<script>
  export let value = '';
  export let placeholder = '';
  export let type = 'text';
  export let error = '';
  export let label = '';
  export let id = '';
  export let disabled = false;
  export let fullWidth = true;

  function handleInput(event) {
    value = event.target.value;
  }
</script>

<div class="{fullWidth ? 'w-full' : ''}">
  {#if label}
    <label for={id} class="block text-sm font-medium mb-2" style="font-family: var(--font-body); color: var(--fg);">
      {label}
    </label>
  {/if}

  <input
    {id}
    type={type}
    {placeholder}
    {disabled}
    {value}
    on:input={handleInput}
    class="input-field {fullWidth ? 'w-full' : ''} {error ? 'input-error' : ''} {disabled ? 'input-disabled' : ''}"
    on:blur
    on:focus
  />

  {#if error}
    <p class="mt-2 text-sm" style="color: #DC2626;" role="alert">
      {error}
    </p>
  {/if}
</div>

<style>
  .input-field {
    padding: 12px 16px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    background: var(--bg-raised);
    color: var(--fg);
    font-family: var(--font-body);
    transition: all var(--dur-med) var(--ease-out);
  }

  .input-field::placeholder {
    color: var(--fg-subtle);
  }

  .input-field:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px rgba(30, 90, 126, 0.1);
  }

  .input-field.input-error {
    border-color: #DC2626;
  }

  .input-field.input-error:focus {
    border-color: #DC2626;
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
  }

  .input-field.input-disabled {
    background: var(--bg-sunken);
    cursor: not-allowed;
    opacity: 0.6;
  }
</style>
